export default __webpack_public_path__ + "static/media/tabler-icon-warning.3a0de4f1.svg";